// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import router from './router'
import './style/reset.css'
import './style/global.less'
Vue.config.productionTip = false;
// import ViewUI from 'view-design';
import 'view-design/dist/styles/iview.css';
import empty from '@/assets/img/loading.gif';
import VueLazyload from 'vue-lazyload'

// Vue.use(ViewUI);
import { Carousel, CarouselItem, Icon, Modal, BackTop } from 'view-design';
Vue.component('Carousel', Carousel);
Vue.component('Icon', Icon);
Vue.component('Modal', Modal);
Vue.component('BackTop', BackTop);

Vue.component('CarouselItem', CarouselItem);

const loadimage = require('./assets/img/loading.gif')
Vue.use(VueLazyload)

Vue.use(VueLazyload, {
  preLoad: 1.3,
  // error: errorimage,
  loading: loadimage,
  attempt: 1
})

/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  components: { App },
  template: '<App/>'
})



// WEBPACK FOOTER //
// ./src/main.js